export default __webpack_public_path__ + "static/questions-back-82240c7ec13dd09970c557de7c3e5a24.webp";